import getConfig from 'next/config'

const {
  publicRuntimeConfig: { optimizelyDataPlatformId, optimizelyId },
} = getConfig()

const getStringifiedOdpScript = (odpId: string) => {
  return `var zaius = window['zaius']||(window['zaius']=[]);zaius.methods=["initialize","onload","customer","entity","event","subscribe","unsubscribe","consent","identify","anonymize","dispatch"];zaius.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);zaius.push(t);return zaius}};(function(){for(var i=0;i<zaius.methods.length;i++){var method=zaius.methods[i];zaius[method]=zaius.factory(method)}var e=document.createElement("script");e.type="text/javascript";e.async=true;e.src=("https:"===document.location.protocol?"https://":"http://")+"d1igp3oop3iho5.cloudfront.net/v2/${odpId}/zaius-min.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();

  // Edits to this script should only be made below this line.
  zaius.event('pageview');`
}

export const OptimizelyWebScripts = () => {
  const rawOdpScript = optimizelyDataPlatformId
    ? getStringifiedOdpScript(optimizelyDataPlatformId)
    : null

  return (
    <>
      {optimizelyId && (
        <script src={`https://cdn.optimizely.com/js/${optimizelyId}.js`} />
      )}
      {rawOdpScript && (
        <script
          type="text/javascript" // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: rawOdpScript,
          }}
        />
      )}
    </>
  )
}
